import React, {useContext} from "react";
import GlobalContext from "../GlobalContext";

const Legend = () => {

  const CONTEXT = useContext(GlobalContext);
  const SQUARE_DIMENSIONS = "35px";

  function createEventTypeLegend(style, name) {
    return <div className="d-flex align-items-center mt-2">
        <span
          style={{height: SQUARE_DIMENSIONS, width: SQUARE_DIMENSIONS}}
          className={"d-inline-block mr-2 " + style + " color-text-white"}
        >
        </span>
      <span>{name}</span>
    </div>
  }

  return (
    <div className="legend float-xs-right float-sm-right float-md-right d-md-inline-block">
    <p className="color-text-orange mb-0 mt-3">
      {Drupal.t("AmRest events")}:
    </p>
      {createEventTypeLegend(CONTEXT.EVENT_TYPE.periodical_report.class, Drupal.t("Periodical reports"))}
      {createEventTypeLegend(CONTEXT.EVENT_TYPE.closed_period.class, Drupal.t("Closed periods"))}
      {createEventTypeLegend(CONTEXT.EVENT_TYPE.corporate_event.class, Drupal.t("Corporate events"))}
    </div>
  );
};

export default Legend;
